import {Entity} from '@s-ui/domain'

/**
 * @implements Entity
 */
export class AppointmentSellerEntity extends Entity {
  /**
   * @param {Object}  deps
   * @param {String}  deps.id
   * @param {String}  deps.from
   * @param {String}  deps.to
   */

  static create = ({id, from, to}) =>
    new AppointmentSellerEntity({
      id,
      from,
      to
    })

  getId() {
    return this._id
  }

  getFrom() {
    return this._from
  }

  getTo() {
    return this._to
  }

  toJSON() {
    return {
      id: this._id,
      from: this._from,
      to: this._to
    }
  }
}
